<div class="labels-help my-2 mx-0">
  <div class="row">
    <div class="col-md-6 col-lg-4 col-xl-3">
      <div class="help-label label-formula label-action-total-ddbb">
        <div class="label-header">Total clientes BBDD</div>
        <div>=</div>
        <div class="label-description">Total de clientes registrados en tu BBDD</div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 col-xl-3">
      <div class="help-label label-action-conversions label-formula">
        <div>%</div>
        <div class="label-header">Éxito</div>
        <div>=</div>
        <div class="label-description">
          <div class="label-division">
            <div class="label-operator">nº total de contactos entregados correctamente</div>
            <div class="visually-hidden"> / </div>
            <div class="label-operator">nº total clientes BBDD</div>
          </div>
          <div class="label-multiplier"><i class="fa fa-times"></i> 100</div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 col-xl-3">
      <div class="help-label label-action-rebote label-formula">
        <div>%</div>
        <div class="label-header">Rebote</div>
        <div>=</div>
        <div class="label-description">
          <div class="label-division">
            <div class="label-operator">nº total de contactos no entregados</div>
            <div class="visually-hidden"> / </div>
            <div class="label-operator">nº total clientes BBDD</div>
          </div>
          <div class="label-multiplier"><i class="fa fa-times"></i> 100</div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 col-xl-3">
      <div class="help-label label-action-open label-formula">
        <div>%</div>
        <div class="label-header">Abiertos</div>
        <div>=</div>
        <div class="label-description">
          <div class="label-division">
            <div class="label-operator">nº total de contactos con apertura</div>
            <div class="visually-hidden"> / </div>
            <div class="label-operator">nº total contactos con éxito</div>
          </div>
          <div class="label-multiplier"><i class="fa fa-times"></i> 100</div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-lg-4 col-xl-3">
      <div class="help-label label-clics label-formula">
        <div>%</div>
        <div class="label-header">Clics</div>
        <div>=</div>
        <div class="label-description">
          <div class="label-division">
            <div class="label-operator">nº total de clics en al menos un link</div>
            <div class="visually-hidden"> / </div>
            <div class="label-operator">nº total abiertos</div>
          </div>
          <div class="label-multiplier"><i class="fa fa-times"></i> 100</div>
        </div>
      </div>
    </div>
    <div class="label-action-visits-container col-md-6 col-lg-4 col-xl-3">
      <div class="help-label label-action-visits label-formula">
        <div>%</div>
        <div class="label-header">Visitas taller</div>
        <div>=</div>
        <div class="label-description">
          <div class="label-division">
            <div class="label-operator">nº total de visitas recibidas taller</div>
            <div class="visually-hidden"> / </div>
            <div class="label-operator">nº total contactos con éxito</div>
          </div>
          <div class="label-multiplier"><i class="fa fa-times"></i> 100</div>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="help-label label-formula">
                <div>%</div>
                <div class="label-header">Reactividad</div>
                <div>=</div>
                <div class="label-description">
                    <div class="label-division">
                        <div class="label-operator">nº total de clics sin tener en cuenta usuarios únicos</div>
                        <div class="visually-hidden"> / </div>
                        <div class="label-operator">nº total abiertos</div>
                    </div>
                    <div class="label-multiplier"><i class="fa fa-times"></i> 100</div>
                </div>
            </div>
        </div> -->
    <div class="col-md-6 col-lg-4 col-xl-3">
      <div class="help-label label-formula">
        <div>%</div>
        <div class="label-header">Bajas</div>
        <div>=</div>
        <div class="label-description">
          <div class="label-division">
            <div class="label-operator">nº total de clientes dados de baja</div>
            <div class="visually-hidden"> / </div>
            <div class="label-operator">nº total abiertos</div>
          </div>
          <div class="label-multiplier"><i class="fa fa-times"></i> 100</div>
        </div>
      </div>
    </div>
  </div>
</div>
